<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.01.18</b> - Chat system update</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Chat
        <ul>
          <li>
            - Instead of having a single, global chat channel... chat rooms are now
            separated by language, as well as limited to 200 players each.
          </li>
          <li>
            - Introduced three new chat commands:
            <code>/mute &lt;player&gt;</code>, <code>/unmute &lt;player&gt;</code>, and
            <code>/muted</code> (to get a list of muted players).
          </li>
          <li>- You can no longer inject HTML into the chat :)</li>
          <li>
            - Posting links in chat is disallowed now, except for a whitelist. DM rob-wfs
            on Discord if you want something added to the whitelist.
          </li>
        </ul>
      </li>
      <li>
        AI
        <ul>
          <li>
            - Summon Dwarf will now target tiles near the nearest enemy, not next to the
            caster.
          </li>
          <li>- Support units should no longer send mana to summoned units.</li>
          <li>
            - Caverns squads will now buff & summon while rooms are empty, instead of
            doing nothing.
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
